import { IconAlert, IconCheck } from '@/components/icons'
import { useToastStore } from '@/lib/toast'

export function Toaster() {
  const toasts = useToastStore((state) => state.toasts)
  const dismiss = useToastStore((state) => state.dismiss)
  if (toasts.length === 0) return null

  return (
    <div
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 bottom-[84px] z-30 flex flex-col items-center gap-2 px-4 md:bottom-6 md:left-[var(--sidebar-w,0px)]"
    >
      {toasts.map((item) => {
        const Icon = item.tone === 'success' ? IconCheck : IconAlert
        return (
          <button
            key={item.id}
            type="button"
            role="status"
            onClick={() => dismiss(item.id)}
            className={
              'rise pointer-events-auto flex max-w-sm items-center gap-2.5 rounded-xl px-4 py-3 text-sm font-medium shadow-lift ' +
              (item.tone === 'success'
                ? 'bg-[var(--toast-bg)] text-[var(--toast-fg)]'
                : 'border border-red-200 bg-red-50 text-red-800')
            }
          >
            <Icon size={17} className={item.tone === 'success' ? 'text-brand-300' : ''} />
            <span className="text-left">{item.message}</span>
          </button>
        )
      })}
    </div>
  )
}
